<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="160px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="导入起始日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.startImportTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="导入结束日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.endImportTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="导入开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="导入结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('mbrwtjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._v"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/目标任务统计表--导入.xls" download="目标任务统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="目标任务统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" :rules="rules" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="户籍地址：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="新增就业人数：">
                          <el-input style="width:193px;" v-model="editForm.addJobCount"></el-input>
                        </el-form-item>
                        <el-form-item label="两后生培训人数：">
                          <el-input style="width:193px;" v-model="editForm.twoAfterTraining"></el-input>
                        </el-form-item>
                        <el-form-item label="未脱贫贫困劳动力人数：">
                          <el-input style="width:193px;" v-model="editForm.poorLaborCount"></el-input>
                        </el-form-item>
                        <el-form-item label="未脱贫贫困劳动力就业人数：">
                          <el-input style="width:193px;" v-model="editForm.haveJobPoorLabor"></el-input>
                        </el-form-item>
                        <el-form-item label="有组织劳务输出人数：">
                          <el-input style="width:193px;" v-model="editForm.organizationOut"></el-input>
                        </el-form-item>
                        <el-form-item label="扶贫车间吸纳就业人数：">
                          <el-input style="width:193px;" v-model="editForm.workShop"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="返乡创业带动就业人数：">
                          <el-input style="width:193px;" v-model="editForm.pioneer"></el-input>
                        </el-form-item>
                        <el-form-item label="扶贫公益性岗位安置就业人数：">
                          <el-input style="width:193px;" v-model="editForm.publicWelfare"></el-input>
                        </el-form-item>
                        <el-form-item label="扶贫车间开发岗位个数：">
                          <el-input style="width:193px;" v-model="editForm.workShopGetPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="建设就业扶贫车间数量：">
                          <el-input style="width:193px;" v-model="editForm.buildWorkshop"></el-input>
                        </el-form-item>
                        <el-form-item label="扶贫车间开发岗位个数：">
                          <el-input style="width:193px;" v-model="editForm.workShopOpenJob"></el-input>
                        </el-form-item>
                        <el-form-item label="导入时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.time"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/targetTask',
      form:{},
      type:'27',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      rules:{},
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'addJobCount', value: '新增就业人数'},
        {key: 'twoAfterTraining', value: '两后生培训人数'},
        {key: 'poorLaborCount', value: '未脱贫贫困劳动力人数'},
        {key: 'haveJobPoorLabor', value: '未脱贫贫困劳动力就业人数'},
        {key: 'organizationOut', value: '有组织劳务输出人数'},
        {key: 'workShop', value: '扶贫车间吸纳就业人数'},
        {key: 'pioneer', value: '返乡创业带动就业人数'},
        {key: 'publicWelfare', value: '扶贫公益性岗位安置就业人数'},
        {key: 'workShopGetPersons', value: '扶贫车间吸纳贫困劳动力数'},
        {key: 'buildWorkshop', value: '建设就业扶贫车间数量'},
        {key: 'workShopOpenJob', value: '扶贫车间开发岗位个数'},
        {key: 'time', value: '导入时间'},
      ],
      baseInfo1:[
        {key: 'areaName', value: '行政区划'},
        {key: 'addJobCount', value: '新增就业人数'},
        {key: 'twoAfterTraining', value: '两后生培训人数'},
        {key: 'poorLaborCount', value: '未脱贫贫困劳动力人数'},
        {key: 'haveJobPoorLabor', value: '未脱贫贫困劳动力就业人数'},
        {key: 'organizationOut', value: '有组织劳务输出人数'},
        {key: 'workShop', value: '扶贫车间吸纳就业人数'},
        {key: 'pioneer', value: '返乡创业带动就业人数'},
        {key: 'publicWelfare', value: '扶贫公益性岗位安置就业人数'},
        {key: 'workShopGetPersons', value: '扶贫车间吸纳贫困劳动力数'},
        {key: 'buildWorkshop', value: '建设就业扶贫车间数量'},
        {key: 'workShopOpenJob', value: '扶贫车间开发岗位个数'},
      ],
      isCreate:false,
      out:false,
    }
  },
  created() {
    this.isShowBtn("TargetTask")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },

    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.time = new Date(newForm.time).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>